import i18n from 'src/i18n';

const configTable = () => {
  const tableColumns = [
    {
      prop: 'code',
      label: i18n.t('common_words.code'),
      sortable: true,
      align: 'center',
    },
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      sortable: true,
      minWidth: 180,
    },
    {
      prop: 'description',
      label: i18n.t('common_words.description'),
      minWidth: 300,
    },
  ];

  return { tableColumns };
};

export default configTable;
